import React from 'react'
import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'
import CustomLink from '@shared/components/customLink'

// eslint-disable-next-line react/prop-types
const Timeline = ({ timeline = [] }) => {
  return (
    <>
      <div className={`${styles.timeline}`}>
        {/* eslint-disable-next-line react/prop-types */}
        {timeline.map((data, index) => {
          return (
            <CustomLink key={index} href={data?.link}>
              <div className={`${styles.timeline_content} cursor-pointer`}>
                <div
                  className={`${styles.timeline_img}`}
                  style={{ border: `3px solid ${data.styles.color}`, background: `${data.styles.backgroundColor}` }}>
                  <MyImage src={data.image} alt={data.title} width={60} height={60} className="img-fluid" />
                  {index !== timeline.length - 1 && (
                    <div
                      style={{
                        backgroundColor: data.styles.color
                      }}
                      className={`${styles.bar}`}></div>
                  )}
                </div>
                <div style={{ color: `${data.styles.color}` }} className={index % 2 === 0 ? styles.dot_orange : styles.dot_blue}>
                  ...
                </div>
                <div
                  className={`${styles.timeline_title} ${index % 2 === 0 ? styles.title_orange : styles.title_blue}`}
                  style={{ borderLeft: `4px solid ${data.styles.color}`, background: `${data.styles.backgroundColor}` }}>
                  <span className="fw-bold fs-6">{data.title}</span>
                  <span className={styles.year}>
                    {data.year}{' '}
                    <span className="text-danger fs-4" style={{ marginLeft: '24px' }}>
                      {'->'}
                    </span>
                  </span>
                </div>
              </div>
            </CustomLink>
          )
        })}
        <div className={`${styles.timeline_bar}`}>
          <div className={`${styles.line}`}>
            <span className={`${styles.circle}`}></span>
          </div>
        </div>
      </div>
    </>
  )
}

export default Timeline
